import './perfect-scrollbar.jquery.min'
import './sidebarmenu'
import './waves'
import './custom'



// WEBPACK FOOTER //
// ./resources/assets/command-center/js/scripts/template/index.js